import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M8 8.5a.5.5 0 0 1 .5-.5h3.732a.5.5 0 0 1 .477.35l3.358 10.633c.003.012.014.02.026.02a.028.028 0 0 0 .027-.02l3.175-10.626a.5.5 0 0 1 .48-.357H23.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-2.058a.5.5 0 0 1-.5-.5V12.685a.024.024 0 0 0-.047-.007L17.37 23.653a.5.5 0 0 1-.476.347h-1.79a.5.5 0 0 1-.475-.346L11.105 12.79a.024.024 0 0 0-.047.007V23.5a.5.5 0 0 1-.5.5H8.5a.5.5 0 0 1-.5-.5v-15z"></path><path fill-rule="evenodd" d="M4 5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5zm2 21V6h20v20H6z" clip-rule="evenodd"></path></g>';
export var PublicTransitOutlineSVG = function PublicTransitOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PublicTransitOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PublicTransitOutlineSVG);